var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(window.location.href);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function Filters(el) {
	var t = this,
			category = getUrlParameter('category');
	t.$el = $(el);
	t.$filters = t.$el.find('[data-filter]');
	t.$active = t.$filters.filter('.filters__item--active');
	t.activeFilter = null;
	t.itemSelector = t.$el.data('item-selector');
	t.$items = false;

	if (t.itemSelector) {
		t.$items = $(t.$el.data('item-selector'));
		t.$subFilters = t.$items.find('[data-filter]');
	}

	if ( category ) {
		t.$category = t.$el.find('[data-filter="'+ category + '"]');
		t.selectFilter(t.$category);
	} else {
		t.selectFilter(t.$filters.eq(0));
	}

	t.$filters.on('click', function(e) {
		var $target = $(e.target);

		if ($target.hasClass('js-filters-button')) {
		  $target = $target.closest('.js-filters-item');
    }

		t.selectFilter($target);
	});

	t.$subFilters.on('click', function(e) {
		var $target = $(e.target);

    if ($target.hasClass('filters_button')) {
      $target = $target.closest('.filters_item');
    }

		t.selectFilter($target);
	});

}

Filters.prototype.selectFilter = function ($target) {
	var t = this,
		selectedFilter = $target.data('filter');

	if (selectedFilter == t.activeFilter) {
		return;
	}

	t.$active.removeClass('filters__item--active');
	t.$active.removeClass('bd-second-accent');
	// Find other targets, if possible
	var $newTargets = $('[data-filter="' + selectedFilter + '"]');
	if( $newTargets.length ) {
		$newTargets.addClass('filters__item--active');
		$newTargets.addClass('bd-second-accent');
	}

	if ( t.$items ) {
		t.$items.removeClass( 'js-filter-visible' );
		t.$items.filter( '[data-filter-type*="|' + selectedFilter + '|"]' ).addClass( 'js-filter-visible' );
	}

	t.activeFilter = selectedFilter;
	t.$active = $newTargets;

	t.$el.trigger('change');


};

module.exports = Filters;
